import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center min-h-[calc(100vh-300px)]" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-2 text-2xl font-bold text-darkgray-800" }, "Appointment Not Found", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 text-darkgray-800" }, "We couldn't find the appointment you're looking for. It may have been cancelled or removed.", -1)

import PortalLayout from '@/layouts/PortalLayout.vue';
    import ButtonComponent from '@/components/ButtonComponent.vue';
    import { ExclamationCircleIcon } from "@heroicons/vue/24/outline";
    import { useRouter } from 'vue-router';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'NotFoundPage',
  setup(__props) {

    const router = useRouter();

    const backToAppointment = () => {
        window.location.replace('/appointment');
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PortalLayout, {
    title: "Appointment Not Found",
    "hide-notification": true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(ExclamationCircleIcon), { class: "w-16 h-16 mx-auto mb-4 text-red-600" }),
          _hoisted_3,
          _hoisted_4,
          _createVNode(ButtonComponent, {
            text: "Go Back to Appointments",
            onClick: backToAppointment
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})